import { CSSProperties, FC, ReactNode } from 'react';

import WorkspaceResourceListSkeleton from './Skeleton';

interface WorkspaceResourceListBodyProps {
    children: ReactNode;
    empty: ReactNode;
    hasItems: boolean;
    loading: boolean;
    rows?: number;
    style?: CSSProperties;
}

/** A consistent, layout-stable content boundary for workspace-resource lists. */
const WorkspaceResourceListBody: FC<WorkspaceResourceListBodyProps> = ({
    children,
    empty,
    hasItems,
    loading,
    rows = 12,
    style,
}) => (
    <div style={{ flex: '1 1 0', height: '100%', minHeight: 0, overflow: 'hidden', ...style }}>
        {loading ? <WorkspaceResourceListSkeleton rows={rows} /> : hasItems ? children : empty}
    </div>
);

export default WorkspaceResourceListBody;
